// Shared "coming soon" placeholder for widgets whose real data isn't wired yet.
//
// Some team-scoped widgets (the player/discipline "club" family) still only have
// dummy data keyed to the original 10 teams — so once the full 380-fixture
// selector is on, they'd show a bare "No data" on most fixtures. Rather than a
// half-working dummy, these render this deliberate placeholder on EVERY fixture
// (decision: Option A — consistent, reads as an intentional next milestone). It's
// wired at the bridge (react-bridge REGISTRY), so the real components stay intact
// and dormant, ready to re-enable when real player data lands. Styling:
// `.module-coming-soon` in styles.css.

export interface WidgetComingSoonProps {
  /** Short label naming what's landing, e.g. "Top scorers". Shown as a subtitle. */
  label?: string;
}

export default function WidgetComingSoon({ label }: WidgetComingSoonProps) {
  return (
    <div className="data-wrapper top-align">
      <div className="module-coming-soon">
        <div className="mcs-title">Coming soon</div>
        {label ? <div className="mcs-sub">{label}</div> : null}
      </div>
    </div>
  );
}
